import { store, getParams, addParams } from '@dt/fe-utils'
import { getPlatform } from '@utils'

/**
 * zf授权处理
 * return boolean 是否继续授权公众号
 */
export default async function (memberData?: any) {
  const params = getParams()
  const { BRANDID } = Config
  const { isWeixin, isWeixinMiniProgram, isAliPayMiniProgram, isAlipay } = getPlatform()
  const matchs = document.location.pathname.match(/^\/([^/]*)\/?/)
  const pathState = matchs ? matchs[1] : ''
  // 这些页面不需要处理
  if (['mergeqr', 'mergeqrv2', 'jumpWx', 'notWeixin', 'result'].includes(pathState)) return true
  // 当前是授权页就不需要再跳转，但是需要禁止授权公众号
  if (['authAgreement'].includes(pathState)) return false
  // 国内，并且是非授权页，并且是未授权, 不在微信小程序环境内，但是在微信浏览器内
  const agreementStore = store.get(`ls.agreement.${BRANDID}`)
  const isCanAgreement = ['cn'].includes(bo) && ((isWeixin && !isWeixinMiniProgram) || (isAlipay && !isAliPayMiniProgram)) && (memberData ? !memberData?.member?.agreeTime && !agreementStore : !agreementStore)
  if (isCanAgreement) {
    const url = addParams({
      url: location.origin + '/authAgreement',
      params: { ...params, jumpUrl: encodeURIComponent(location.href), pathState }
    })
    location.replace(url)
    return false
  }
  return true
}
